import { useStore } from "stook";

interface IUploadImage {
  url: string;
  key?: any;
  extra?: any;
}
let INIT_IMAGES_DATA: IUploadImage[] = [];

if (process.env.REACT_APP_DELOY_ENV === "test") {
  INIT_IMAGES_DATA = [];
}

export default function useUploadImages() {
  const [uploadImages, setUploadImages] = useStore<IUploadImage[]>(
    "uploadImages",
    INIT_IMAGES_DATA,
  );

  const resetUploadImages = () => {
    setUploadImages(INIT_IMAGES_DATA);
  };

  return {
    uploadImages,
    setUploadImages,
    resetUploadImages,
  };
}
